import classNames from "classnames";

import { TrashIcon } from "../../AscIcons";
import AscTextInput, {
  AscTextInputProps,
} from "../../AscInputFields/AscTextInput/AscTextInput";

import styles from "./AscActivityAnswerCardForm.module.scss";

export interface AscActivityAnswerCardFormProps {
  className?: string;
  name?: string;
  defaultValue?: string;
  value?: string;
  onChange?: AscTextInputProps["onChange"];
  onBlur?: AscTextInputProps["onBlur"];
  onDelete?: () => void;
  canDelete?: boolean;
}

export default function AscActivityAnswerCardForm({
  className,
  name,
  defaultValue,
  value,
  onBlur,
  onChange,
  onDelete,
  canDelete = false,
}: AscActivityAnswerCardFormProps) {
  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    onChange?.(e);
  }
  return (
    <div className={classNames(styles.ground, className)}>
      <div className={styles.form}>
        <div className={styles.formField}>
          <div className={styles.inputField}>
            <AscTextInput
              fullWidth={true}
              placeholder="Enter title"
              id="title"
              value={value}
              name={name}
              onChange={handleChange}
              onBlur={onBlur}
              defaultValue={defaultValue}
            />

            <hr className={styles.hR} />

            <TrashIcon
              onClick={canDelete ? onDelete : undefined}
              className={classNames(styles.icon, {
                [styles.iconDisabled]: !canDelete,
              })}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
